import { useEffect } from "react";
import AxiosInstance from "src/components/Axios";

const Home = () => {
    return <>Вітаємо!</>
}

export default Home;